export const criteriaWithComplexValues = [
	'search_by_tags',
	'search_by_checklists',
];

export type IcriteriaWithComplexValues = 'search_by_tags' | 'search_by_checklists';
